export default __webpack_public_path__ + "static/media/32.73abc9ce.jpg";